var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"padding bg",attrs:{"fluid":""}},[( !_vm.$store.state.hideNavBar )?_c('main-nav'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }